import { GoogleMap } from '@react-google-maps/api';

import * as St from './RetailStoresMap.styles';
import { useRetailStoresMap } from './hooks/useRetailStoresMap';

interface RetailStoresMapProps {
  disabled?: boolean;
}

const RetailStoresMap = ({ disabled }: RetailStoresMapProps) => {
  const {
    setMap,
    isGoogleMapsLoaded,
    onMapLoad,
    googleMapsOptions,
    googleMapsError,
  } = useRetailStoresMap({ disabled });

  if (!isGoogleMapsLoaded || googleMapsError) {
    return null;
  }

  return (
    <GoogleMap
      mapContainerStyle={St.googleMapStyle}
      options={googleMapsOptions}
      onLoad={onMapLoad}
      onUnmount={() => setMap(null)}
    />
  );
};

export default RetailStoresMap;
